export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["进行中"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已完成"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待处理"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一个"])}
}